import { render, staticRenderFns } from "./AcizBelgesiHazirlanmasiTalepEvrakForm.vue?vue&type=template&id=2e59aa39"
import script from "./AcizBelgesiHazirlanmasiTalepEvrakForm.vue?vue&type=script&lang=ts"
export * from "./AcizBelgesiHazirlanmasiTalepEvrakForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports